import { serviceRoles } from "config/access";
import { SKILL_TAGS } from "constants/routes";
import { checkAccess } from "helpers/auth";
import SkillTagsPage from "./container/SkillTagsPage";

export default function getSettingsRoute(requireAuthFunctions) {
  const { account, cpfm } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin],
    [cpfm.name]: [cpfm.roles.admin],
  };
  return {
    path: SKILL_TAGS,
    onEnter: () => checkAccess(requireAuth, requireAuthFunctions),
    withSidebar: true,
    withAppBar: true,
    component: SkillTagsPage,
  };
}
